/// <reference path="../../node_modules/microsoft-cognitiveservices-speech-sdk/distrib/lib/microsoft.cognitiveservices.speech.sdk.d.ts" />

/***
 * https://learn.microsoft.com/en-us/azure/ai-services/speech-service/get-speech-recognition-results?pivots=programming-language-csharp
 * https://github.com/Azure-Samples/cognitive-services-speech-sdk
 */
declare const SpeechSDK: any;

/* eslint-disable-next-line */
var aptSpeechServices: any = aptSpeechServices || {}
aptSpeechServices = (function ($: JQueryStatic) {
	let _btnRecord: JQuery<HTMLButtonElement>
	let _btnStop: JQuery<HTMLButtonElement>
	let _textArea: JQuery<HTMLTextAreaElement>
	let _alertPlaceholder: JQuery<HTMLElement>
	let _alert: string
	let speechConfig: any //SpeechSDK.SpeechConfig
	let audioConfig: any //SpeechSDK.AudioConfig
	let speechRecognizer: any //SpeechSDK.SpeechRecognizer
	let lastRecognizedText: string = "" // track the last recognized text
	//speechConfig.setProperty(SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs, "2000"); // 2 seconds of silence

	function init() {
		_btnRecord = $('#textareaSpeechRecord')
		_btnStop = $('#textareaSpeechStop')
		_textArea = _btnRecord.closest('.textarea-wrapper').find('textarea')
		_alertPlaceholder = $('#alertPlaceholder')

		_btnRecord.on('click', handleRecordClick)
		_btnStop.on('click', handleStopClick)

		$('.next, .previous').on('click', () => _btnStop.trigger('click'))
	}

	function handleRecordClick() {
		_alertPlaceholder.empty()
		navigator.mediaDevices
			.getUserMedia({ audio: true })
			.then(() => {
				getSpeechToken((token: string) => {
					startRecording(token)
					toggleButtons(true)
				})
			})
			.catch((e) => {
				console.error('Error accessing microphone:', e)
				$('.stt-link').remove()
			})
	}

	function handleStopClick() {
		stopRecording()
		toggleButtons(false)
	}

	function toggleButtons(isRecording: boolean) {
		_btnRecord.toggle(!isRecording)
		_btnStop.toggle(isRecording)
	}
	function getSpeechToken(callback: (token: string) => void) {
		const _webId: string = $('#WebID').val() as string
		$.ajax({
			url: `../Speech/GetSpeechToken?WebID=${_webId}`,
			type: 'GET',
			success: function (token) {
				callback(token)
			},
			error: function (xhr, status, error) {
				console.error('Error fetching token', status, error)
				showAlert('Sorry, the recording service is not available at this time.')
			}
		})
	}

	function startRecording(token: string) {
		if (!token) {
			console.error('Speech token is not available')
			return
		}

		try {
			speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(token, 'eastus')
			audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput()
			speechRecognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig)

			_textArea.addClass('disabled').prop('disabled', 'disabled')

			speechRecognizer.recognized = (s: any, e: any) => {
				if (e.result.reason == SpeechSDK.ResultReason.RecognizedSpeech) {
					const newText = e.result.text.trim() // Get the new recognized text
					if (newText !== lastRecognizedText) { // Check if it's different from the last recognized text
						const currentText = _textArea.val() as string
						const updatedText = `${currentText} ${newText}`.trim()
						console.info("Recognized text:", newText)
						_textArea.val(updatedText).trigger("focus")
						lastRecognizedText = newText // Update the last recognized text
					} else {
						console.info("Duplicate text ignored:", newText)
					}
				}
			}

			speechRecognizer.startContinuousRecognitionAsync(
				() => console.log('Recognition started'),
				(err: string) => {
					console.error(`Error starting recognition: ${err}`)
					showAlert('Unable to find your mic. Please check if it is connected.')
					handleStopClick()
				}
			)
		} catch (err) {
			console.error('Error initializing speech recognizer:', err)
			showAlert('An error occurred while starting the speech recognizer.')
		}
	}

	function stopRecording() {
		_textArea.removeClass('disabled').removeAttr('disabled')
		lastRecognizedText = "" // Reset the last recognized text
		if (speechRecognizer) {
			speechRecognizer.stopContinuousRecognitionAsync(
				() => {
					speechRecognizer.close()
					speechRecognizer = undefined
				},
				(err: string) => console.error(`Error stopping recognition: ${err}`)
			)
		} else {
			console.warn('Speech recognizer is already undefined.')
		}
	}

	function showAlert(message: string) {
		_alert = `<span class="text-danger">${message}</span>`
		_alertPlaceholder.html(_alert)
	}

	return {
		init,
		showAlert
	}
})($)